<template>
  <div class="login-page">
    <div class="login-card card">
      <div class="card-body">
        <div class="text-center mb-4">
          <img src="@/assets/logo-dark.png" alt="Nexyo" class="login-logo" />
          <h5 class="mt-3 mb-0">Panel administrativo</h5>
          <p class="text-muted small">Inicia sesión con tu cuenta</p>
        </div>
        <form @submit.prevent="onSubmit">
          <div v-if="error" class="alert alert-danger py-2 small">{{ error }}</div>
          <div class="mb-3">
            <label class="form-label">Correo electrónico</label>
            <input
              v-model="email"
              type="email"
              class="form-control"
              placeholder="admin@nexyo.com"
              required
              autocomplete="email"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Contraseña</label>
            <input
              v-model="password"
              type="password"
              class="form-control"
              placeholder="••••••••"
              required
              autocomplete="current-password"
            />
          </div>
          <button type="submit" class="btn btn-primary w-100" :disabled="loading">
            <span v-if="loading">Entrando...</span>
            <span v-else>Iniciar sesión</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { normalizeApiError } from '@/utils/error-handler';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: null,
    };
  },
  methods: {
    ...mapActions('auth', ['login']),
    async onSubmit() {
      this.error = null;
      this.loading = true;
      try {
        await this.login({ email: this.email, password: this.password });
        this.$router.replace('/');
      } catch (e) {
        this.error = normalizeApiError(e, 'Credenciales incorrectas. Intenta de nuevo.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--body-color, #f4f4f4);
}
.login-card {
  width: 100%;
  max-width: 400px;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}
.login-logo {
  max-width: 140px;
  height: auto;
}
.btn-primary {
  background-color: #fbc903;
  border-color: #fbc903;
  color: #151824;
  font-weight: 600;
  &:hover {
    background-color: #e5b002;
    border-color: #e5b002;
    color: #151824;
  }
}
</style>
